import { useQuery } from "@tanstack/react-query";
import { useGetAccessPermission } from "src/hooks/useGetAccessPermission";
import { getProductCategory } from "src/services/ProductCategory.service";
import { AccessResource, ActionType } from "src/types/accessControl";

export const useGetProductCategory = () => {
  const isAllowedProductCategory = useGetAccessPermission({
    resource: AccessResource["Master Data - Product Category"],
    action: ActionType["Read"],
  });
  return useQuery({
    queryKey: ["product-category"],
    queryFn: () => getProductCategory(),
    enabled: isAllowedProductCategory,
    retry: false,
  });
};
